import React, { useEffect, useState } from "react";
import { Avatar, Col, Menu, Row, Tag } from "antd";
import { Link, useHistory } from "react-router-dom";
import CustomScrollbars from "util/CustomScrollbars";
import "./SidebarStyles.css";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  LIGHT_PURPLE,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import logorace from "../../assets/img/locorace.png";
import logodashboard from "../../assets/img/icondashoardrace.png";
import historyrace from "../../assets/img/historyrace.png";
import splistrace from "../../assets/img/sprace.png";
import perbaikanrace from "../../assets/img/perbaikanrace.png";
import vehiclerace from "../../assets/img/vehicle.png";
import emergencyrace from "../../assets/img/emergencyrace.png";
import DriverLogo from "../../assets/img/Driver@4x.png";
import CodLogo from "../../assets/img/Cod.png";
import ErlanggLogo from "../../assets/img/ErlanggLogo.png";
import SjList from "../../assets/img/SjList.png";
import { Button } from "react-bootstrap";
import {
  CarTwoTone,
  SmileTwoTone,
  ScheduleTwoTone,
  ProfileTwoTone,
  CheckSquareTwoTone,
  PieChartOutlined,
  UserOutlined,
  ExceptionOutlined,
  FileExcelOutlined,
  FileTextOutlined,
  ProfileOutlined,
  FileProtectOutlined,
  DollarOutlined,
  VideoCameraOutlined,
  CarOutlined,
  EnvironmentTwoTone,
  FolderOpenOutlined,
  ShopOutlined,
  FundViewOutlined,
  AppstoreOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import axios from "axios";
import Baseurl from "../../Api/BaseUrl";

import { SyncOutlined, BarChartOutlined, ClockCircleOutlined, EnvironmentOutlined } from "@ant-design/icons";
const getMenuIconInfo = (text) => {
  const map = {
    "Dashboard": { type: "icon", icon: <AppstoreOutlined /> },
    "Erlangga": { type: "icon", icon: <ProfileOutlined /> },
    "SP List": { type: "text", text: "SP" },
    "SJ List": { type: "text", text: "SJ" },
    "SJ Susulan": { type: "text", text: "SJ" },
    "SJ Pending": { type: "text", text: "SJ" },
    "Map Pengiriman": { type: "icon", icon: <EnvironmentOutlined /> },
    "Monitoring Report": { type: "icon", icon: <ClockCircleOutlined /> },
    "Return Order": { type: "icon", icon: <SyncOutlined /> },
    "Report Driver Harian": { type: "icon", icon: <BarChartOutlined /> },
    "Receive SJ": { type: "text", text: "SJ" },
    "History Receive SJ": { type: "icon", icon: <ClockCircleOutlined /> },
    "Master Data": { type: "icon", icon: <AppstoreOutlined /> },
    "Kendaraan": { type: "icon", icon: <CarOutlined /> },
    "Driver": { type: "icon", icon: <UserOutlined /> },
    "Alamat Customer": { type: "icon", icon: <ClockCircleOutlined /> },
    "Lain-lain": { type: "icon", icon: <AppstoreOutlined /> },
    "SM Metrics": { type: "icon", icon: <ProfileOutlined /> },
    "Driver Activity": { type: "icon", icon: <UserOutlined /> },
    "Exec Dashboard": { type: "icon", icon: <PieChartOutlined /> },
    "List Revisi": { type: "icon", icon: <ExceptionOutlined /> },
    "Report Faktur": { type: "icon", icon: <FileTextOutlined /> },
    "Uang Jalan": { type: "icon", icon: <DollarOutlined /> },
    "Scan Barang": { type: "icon", icon: <CheckSquareTwoTone /> },
    "PTJ": { type: "icon", icon: <DollarOutlined /> },
    "Checkin Pool": { type: "icon", icon: <EnvironmentOutlined /> }
  };
  return map[text] || { type: "icon", icon: <AppstoreOutlined /> };
};

const CustomMenuIcon = ({ text, activePath, activeMenu }) => {
  const info = getMenuIconInfo(text);
  // Some links match strictly, some just need to see if activeMenu matches activePath
  // But wait! If we don't have activePath, we can just style it based on the parent!
  // Actually, parent `.menu-item-active` will set child colors if we use CSS inherit!
  // Let's just use CSS inherit!
  return (
    <div
      className="custom-menu-icon"
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "32px",
        height: "32px",
        borderRadius: "8px",
        marginRight: "12px",
        verticalAlign: "middle",
        flexShrink: 0
      }}
    >
      {info.type === "text" ? (
        <span
          className="custom-menu-icon-text"
          style={{
            fontWeight: "bold",
            fontStyle: "italic",
            fontSize: "16px",
            lineHeight: 1
          }}
        >
          {info.text}
        </span>
      ) : (
        React.cloneElement(info.icon, {
          className: "custom-menu-icon-svg",
          style: {
            fontSize: "22px",
          },
        })
      )}
    </div>
  );
};

const { SubMenu } = Menu;

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const history = useHistory();
  // const { dataapprove } = SPlistLamaState()
  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  const MenuItemGroup = Menu.ItemGroup;

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];

  const level = localStorage.getItem("level");
  const jobdesk = localStorage.getItem("jobdesk");
  const fullname = localStorage.getItem(`fullname`);
  const username = localStorage.getItem(`username`);
  const createsp = () => {
    history.push(`/masterdata/marketing/createsp`);
  };
  const createar = () => {
    history.push(`/createar`);
  };
  const createap = () => {
    history.push(`/akunting/tambahdataap`);
  };
  const createuserbaru = () => {
    history.push(`/akunting/usernew`);
  };
  const cabang = localStorage.getItem("cabang");
  const loginBu = localStorage.getItem("loginBu");
  const menuBackgroundColor =
    jobdesk === "rcadmin" ||
    jobdesk === "rcspv" ||
    jobdesk === "rcgudang" ||
    (loginBu && cabang)
      ? "#F05423"
      : "#BAD6FF";

  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname);
  const [DataRequest, setDataRequest] = useState("");
  const items = [
    {
      key: "sub1",
      label: "Navigation One",
      // icon: <MailOutlined />,
      children: [
        {
          key: "g1",
          label: "Item 1",
          type: "group",
          children: [
            {
              key: "1",
              label: "Option 1",
            },
            {
              key: "2",
              label: "Option 2",
            },
          ],
        },
        {
          key: "g2",
          label: "Item 2",
          type: "group",
          children: [
            {
              key: "3",
              label: "Option 3",
            },
            {
              key: "4",
              label: "Option 4",
            },
          ],
        },
      ],
    },
    {
      key: "sub2",
      label: "Navigation Two",
      // icon: <AppstoreOutlined />,
      children: [
        {
          key: "5",
          label: "Option 5",
        },
        {
          key: "6",
          label: "Option 6",
        },
        {
          key: "sub3",
          label: "Submenu",
          children: [
            {
              key: "7",
              label: "Option 7",
            },
            {
              key: "8",
              label: "Option 8",
            },
          ],
        },
      ],
    },
    {
      type: "divider",
    },
    {
      key: "sub4",
      label: "Navigation Three",
      // icon: <SettingOutlined />,
      children: [
        {
          key: "9",
          label: "Option 9",
        },
        {
          key: "10",
          label: "Option 10",
        },
        {
          key: "11",
          label: "Option 11",
        },
        {
          key: "12",
          label: "Option 12",
        },
      ],
    },
    {
      key: "grp",
      label: "Group",
      type: "group",
      children: [
        {
          key: "13",
          label: "Option 13",
        },
        {
          key: "14",
          label: "Option 14",
        },
      ],
    },
  ];
  const fetchData = async () => {
    try {
      const respons = await axios.get(
        `${Baseurl}sp/get-list-purch?limit=&page=1&is_multi=`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        },
      );
      setDataRequest(respons.data.data.totalData);
      console.log("ini data purch", respons.data.data.totalData);
    } catch (error) {}
  };

  useEffect(() => {
    // fetchData();
    setActiveMenu(location.pathname);
  }, [location]);
  console.log(`cabang`, cabang);
  console.log("DEBUG SIDEBAR:", { jobdesk, cabang, level, isCustomer: level?.trim()?.toLowerCase() === "customer" });
  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >
          <Row>
            {!(
              jobdesk === "rcadmin" ||
              jobdesk === "rcspv" ||
              jobdesk === "rcgudang"
            ) && loginBu !== "RaceCabang" ? (
              <Col span={24} className="d-flex justify-content-center">
                <Avatar
                  src={`https://avatars.githubusercontent.com/u/130539563?s=200&v=4`}
                  className="gx-size-50 gx-pointer gx-mr-4"
                  alt=""
                  style={{ width: "100%" }}
                />
                <div>
                  <b style={{ color: "black" }}>{jobdesk}</b>
                  <p style={{ color: "black", fontWeight: "bold" }}>
                    {fullname == "undefined" ? cabang : fullname}
                  </p>
                </div>
              </Col>
            ) : (
              <Col span={24} className="d-flex justify-content-center">
                <img
                  src={logorace}
                  style={{ width: "75px", height: "auto" }}
                  className=" gx-pointer"
                  alt=""
                />
              </Col>
            )}
            {/* {jobdesk != "rcadmin" && (
              <Col span={24} className="d-flex justify-content-center">
                <b style={{ color: "black" }} className="mt-3">
                  {" "}
                  {jobdesk} , {fullname}
                </b>
              </Col>
            )} */}
          </Row>
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            style={{ backgroundColor: menuBackgroundColor }}
            theme={themeType === LIGHT_PURPLE ? "lite" : "dark"}
            mode="inline"
          >
            <MenuItemGroup key="main">
              {jobdesk === "sales" && level == "admin" && level?.trim()?.toLowerCase() !== "customer" ? (
                <div className="d-flex justify-content-center gx-sidebar-content w-100  text-center ">
                  <Button
                    size="lg"
                    style={{
                      width: 180,
                      backgroundColor: "#113D7F",
                      color: "white",
                    }}
                    className="d-flex align-items-center justify-content-center mt-3"
                    onClick={() => createsp()}
                  >
                    Tambah SP
                  </Button>
                </div>
              ) : (
                <></>
              )}

              {jobdesk === "akunting" && loginBu != "RaceCabang" && level?.trim()?.toLowerCase() !== "customer" ? (
                <>
                  {/* <div className="d-flex justify-content-center gx-sidebar-content w-100  text-center ">
                    <Button
                      size="lg"
                      style={{
                        width: 180,
                        backgroundColor: "#00a65a",
                        color: "white",
                      }}
                      className="d-flex align-items-center justify-content-center"
                      onClick={() => createar()}
                      variant="#00a65a"
                    >
                      ADD AR
                    </Button>
                  </div>
                  <div className="d-flex justify-content-center gx-sidebar-content w-100 mt-5 text-center ">
                    <Button
                      size="lg"
                      style={{ width: 180, color: "white", marginTop: "-35px" }}
                      className="d-flex align-items-center justify-content-center"
                      onClick={() => createap()}
                      variant="warning"
                    >
                      ADD AP
                    </Button>
                  </div> */}
                  <div className="d-flex justify-content-center gx-sidebar-content w-100 mt-5 text-center ">
                    <Button
                      size="lg"
                      style={{
                        width: 180,
                        color: "white",
                        marginTop: "-35px",
                        backgroundColor: "#113D7F",
                        color: "white",
                      }}
                      className="d-flex align-items-center justify-content-center"
                      onClick={() => createuserbaru()}
                    >
                      ADD USER BARU
                    </Button>
                  </div>
                </>
              ) : (
                <></>
              )}

              {/* {jobdesk == "webmaster" && (
                <MenuItemGroup key="main" >
                  <Menu.Item key="Dashboard" className={activeMenu === "/dashboard" ? "menu-item-active menu-item-hover" : "menu-item-hover"}>
                    <Link to="/dashboard" style={{ textDecoration: "none" }}>

                      <AppstoreOutlined style={{ fontSize: "30px", color: 'white', marginBottom: '8px' }} />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        <IntlMessages id="Dashboard" />
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="List User" className={activeMenu === "/ListDataUsersss" ? "menu-item-active menu-item-hover" : "menu-item-hover"}>
                    <Link to="/ListDataUsersss" style={{ textDecoration: "none" }}>

                      <UsergroupAddOutlined style={{ fontSize: "30px", color: 'white', marginBottom: '8px' }} />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        <IntlMessages id="List User" />
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="Data User" className={activeMenu === "/DataMenu" ? "menu-item-active menu-item-hover" : "menu-item-hover"}>
                    <Link to="/DataMenu" style={{ textDecoration: "none" }}>

                      <UserOutlined style={{ fontSize: "30px", color: 'white', marginBottom: '8px' }} />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        <IntlMessages id="Data User" />
                      </span>
                    </Link>
                  </Menu.Item>
                </MenuItemGroup>
              )} */}

              {jobdesk == "sales" && level?.trim()?.toLowerCase() !== "customer" && (
                <MenuItemGroup key="main">
                  <Menu.Item
                    key="Dashboard"
                    className={
                      activeMenu === "/dashboard"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/dashboard" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppstoreOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Dashboard" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    // style={{
                    //   backgroundColor: "#0c2197",
                    //   height: "20%",
                    //   marginRight: "20px",
                    //   marginLeft: "20px",
                    //   borderRadius: "10px",
                    // }}
                  >
                    <h6
                      style={{
                        color: "#0c2197",
                        textDecoration: "underline",
                        paddingLeft: "40px",
                      }}
                      className="mt-3 mb-3"
                    >
                      Pesanan
                    </h6>
                  </div>
                  <Menu.Item
                    key="SP List"
                    className={
                      activeMenu === "/masterdata/marketing/splist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/marketing/splist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FileTextOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="SP List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Cancel SP List"
                    className={
                      activeMenu === "/masterdata/marketing/cancelsplist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/marketing/cancelsplist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FileExcelOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Cancel SP List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    // style={{
                    //   backgroundColor: "#0c2197",
                    //   height: "20%",
                    //   marginRight: "20px",
                    //   marginLeft: "20px",
                    //   borderRadius: "10px",
                    // }}
                  >
                    <h6
                      style={{
                        color: "#0c2197",
                        textDecoration: "underline",
                        paddingLeft: "40px",
                      }}
                      className="mt-3 mb-3 "
                    >
                      Master
                    </h6>
                  </div>
                  <Menu.Item
                    key="MasterCustomer"
                    className={
                      activeMenu === "/ReportCustomer"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/ReportCustomer"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserSwitchOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Report Customer
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="LoseSale"
                    className={
                      activeMenu === "/LoseSale"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/LoseSale" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserSwitchOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Lose Sale
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Data Wilayah"
                    className={
                      activeMenu === "/mastercustomersss"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/mastercustomersss"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Customer
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Alamat Customer"
                    className={
                      activeMenu === "/alamatcustomer"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/alamatcustomer"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ProfileOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Alamat Customer
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Alamat Invoice"
                    className={
                      activeMenu === "/invoicecustomer"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/invoicecustomer"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FileProtectOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Alamat Invoice
                        </span>
                      </div>
                      {/* <span style={{ fontWeight: "bold",  color: 'white' }}>Data Alamat All</span> */}
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Cari Tarif"
                    className={
                      activeMenu === "/CariTarif"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/CariTarif" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Cari Tarif
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Tarif Customer"
                    className={
                      activeMenu === "/pelanggantarif"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/pelanggantarif"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Tarif Customer
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    // style={{
                    //   backgroundColor: "#0c2197",
                    //   height: "20%",
                    //   marginRight: "20px",
                    //   marginLeft: "20px",
                    //   borderRadius: "10px",
                    // }}
                  >
                    <h6
                      style={{
                        color: "#0c2197",
                        textDecoration: "underline",
                        paddingLeft: "40px",
                      }}
                      className="mt-3 mb-3 "
                    >
                      Lain - Lain
                    </h6>
                  </div>
                  <Menu.Item
                    disabled
                    key="monitoringVehicle"
                    className={
                      activeMenu === "/masterdata/monitoring"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/monitoring"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <VideoCameraOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Monitoring Vehicle" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                </MenuItemGroup>
              )}

              {jobdesk == "operasional" && level?.trim()?.toLowerCase() !== "customer" && (
                <Menu.ItemGroup key="master">
                  <Menu.Item
                    key="Dashboard"
                    className={
                      activeMenu === "/dashboard"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/dashboard" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppstoreOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Dashboard" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>

                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Menu SP
                    </h6>
                  </div>
                  <Menu.Item
                    key="waiting SP List"
                    className={
                      activeMenu === "/masterdata/newsplist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/newsplist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ProfileTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Waiting SP" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item key="New SP" className={activeMenu === "/masterdata/newsplist" ? "menu-item-active menu-item-hover" : "menu-item-hover"} >
                    <Link
                      to="/masterdata/newsplist"
                      style={{ textDecoration: "none" }}
                    >
                      <CheckSquareTwoTone style={{ fontSize: "30px", color: 'white',  marginBottom: '7px' }} />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        <IntlMessages id="Approve SP" />
                      </span>
                    </Link>
                  </Menu.Item> */}
                  <Menu.Item
                    key="SP List"
                    className={
                      activeMenu === "/masterdata/splist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/splist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ProfileTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="SP List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Menu SJ
                    </h6>
                  </div>
                  <Menu.Item
                    key="SJ List"
                    className={
                      activeMenu === "/masterdata/sjlist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/sjlist"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FolderOpenOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="SJ List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="monitoring"
                    className={
                      activeMenu === "/monitoringSJ"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/monitoringSJ" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ScheduleTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Monitoring SJ" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="monitoringKiriman"
                    className={
                      activeMenu === "/monitoringReportKiriman"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/monitoringReportKiriman"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ScheduleTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Monitoring Kiriman" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "40px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3"
                    >
                      Driver
                    </h6>
                  </div>
                  <Menu.Item
                    key="driver"
                    className={
                      activeMenu === "/masterdata/purchasing/driver"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/purchasing/driver"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SmileTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="sidebar.driver" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    disabled
                    key="DriverMap"
                    className={
                      activeMenu === "/masterdata/monitoring"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/monitoring"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CarTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Driver Map" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    disabled
                    key="DriverEmc"
                    className={
                      activeMenu === "/masterdata/monitoring"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/monitoring"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CarTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Driver Emc" />
                        </span>
                      </div>
                      {/* <i className="icon icon-widgets" /> */}
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Vehicle
                    </h6>
                  </div>

                  <Menu.Item
                    key="VehicleMap"
                    disabled
                    className={
                      activeMenu === "/masterdata/monitoring"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/monitoring"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <EnvironmentTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Vehicle Map" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="vehicle"
                    className={
                      activeMenu === "/masterdata/vehicle"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/vehicle"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CarTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="sidebar.vehicle" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    disabled
                    key="monitoringVehicle"
                    className={
                      activeMenu === "/masterdata/monitoring"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/monitoring"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ScheduleTwoTone
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Monitoring Vehicle" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Laporan
                    </h6>
                  </div>
                  <Menu.Item
                    key="SKU List"
                    className={
                      activeMenu === "/sku-list"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/sku-list" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FundViewOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          SKU List
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                </Menu.ItemGroup>
              )}
              {/* {jobdesk == "operasional" && (
                <Menu.ItemGroup key="monitorings">
                  <Menu.Item key="monitoringVehicle" >
                    <Link to="/masterdata/monitoring">
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold",  color: 'white' }}>
                        <IntlMessages id="Vehicle Map" />
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="monitoringDriver">
                    <Link to="/masterdata/monitoring">
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold",  color: 'white' }}>
                        <IntlMessages id="Driver Map" />
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="DriverEmc">
                    <Link to="/masterdata/monitoring">
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold",  color: 'white' }}>
                        <IntlMessages id="Driver Emc" />
                      </span>
                    </Link>
                  </Menu.Item>
                </Menu.ItemGroup>
              )} */}

              {jobdesk == "akunting" && loginBu != "RaceCabang" && level?.trim()?.toLowerCase() !== "customer" ? (
                <>
                  <Menu.ItemGroup key="akuntingg">
                    <Menu.Item
                      key="Dashboard"
                      className={
                        activeMenu === "/dashboard"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link to="/dashboard" style={{ textDecoration: "none" }}>
                        {/* <i className="icon icon-widgets" />
                         */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <AppstoreOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            <IntlMessages id="Dashboard" />
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                    <div
                      className="d-flex justify-content-start"
                      style={{
                        height: "20%",
                        marginRight: "20px",
                        marginLeft: "20px",
                        borderRadius: "10px",
                      }}
                    >
                      <h6
                        style={{
                          color: "#0c2197",
                          textDecoration: "underline",
                        }}
                        className="mt-3 mb-3 mx-4"
                      >
                        Menu SP
                      </h6>
                    </div>
                    <Menu.Item
                      key="SP Lists"
                      className={
                        activeMenu === "/akunting/splistwaitingakunting"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/akunting/splistwaitingakunting"
                        style={{ textDecoration: "none" }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FileProtectOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            Waiting Approve SP
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="SP Lists All"
                      className={
                        activeMenu === "/akunting/splistakuntingbaru"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/akunting/splistakuntingbaru"
                        style={{ textDecoration: "none" }}
                      >
                        {" "}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FileProtectOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            SP List All
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key="Approve SP"
                      className={
                        activeMenu === "/approvesplistall"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/approvesplistall"
                        style={{ textDecoration: "none" }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FileProtectOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            List Approve All SP
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                  </Menu.ItemGroup>
                  {/* <div
                    className="d-flex justify-content-start"
                    style={{ backgroundColor: "#0c2197", height: "20%", marginRight: '20px', marginLeft: '20px' , borderRadius: '10px' }}
                  >
                    <h6 style={{ color: "white" }} className="mt-3 mb-3 mx-4" >
                      Tarif
                    </h6>
                  </div>
                  <Menu.Item key="Tarif Customer" className={activeMenu === "/pelanggantarif" ? "menu-item-active menu-item-hover" : "menu-item-hover"}>
                    <Link
                      to="/pelanggantarif"
                      style={{ textDecoration: "none" }}
                    >
                      <DollarOutlined style={{ fontSize: "30px", color: 'white',  marginBottom: '8px' }} />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        Tarif Customer
                      </span>
                    </Link>
                  </Menu.Item> 
                  <Menu.Item disabled key="Tarif Eureka" >
                    <Link to="/tarif_eureka" style={{ textDecoration: "none" }}>
                      <DollarOutlined style={{ fontSize: "30px", color: 'white',  marginBottom: '7px' }} />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        Tarif Eureka
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="Tarif Mitra" disabled>

                    <Link to="/tarifmitra" style={{ textDecoration: "none" }}>
                      <DollarOutlined style={{ fontSize: "30px", color: 'white',  marginBottom: '7px' }} />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        Tarif Mitra
                      </span>
                    </Link>
                  </Menu.Item> */}
                  {/* <SubMenu key="monitoring" title="Monitoring">
                    <Menu.Item key="Data Pesanan Customer">
                      <Link to="/akunting/detaildatacustomer" style={{ textDecoration: "none" }}>
                        <i className="icon icon-widgets" />
                        <span style={{ fontWeight: "bold",  color: 'white' }}>Data Customer</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu> */}
                  {/* <div
                    className="d-flex justify-content-center"
                    style={{ backgroundColor: "#0c2197", height: "20%", marginRight: '20px', marginLeft: '20px' , borderRadius: '10px' }}
                  >
                    <h6 style={{ color: "white" }} className="mt-3 mb-3 mx-4" >
                      Menu AR
                    </h6>
                  </div>
                  <Menu.Item key="AR List ALL">
                    <Link
                      to="/akunting/ar/ar"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        AR List ALL
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="List Invoice AR">
                    <Link
                      to="/akunting/ar/ar"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        List Invoice AR
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="SJ no AR">
                    <Link
                      to="/akunting/ar/ar"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        SJ no AR
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="Penerimaan SJ">
                    <Link
                      to="/akunting/ar/ar"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        Penerimaan SJ
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="Report Pembayaran Customer">
                    <Link
                      to="/akunting/ar/ar"
                      style={{ textDecoration: "none" }}
                    >
                      <i className="icon icon-widgets" />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        Report Pembayaran Customer
                      </span>
                    </Link>
                  </Menu.Item> */}

                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Payment
                    </h6>
                  </div>

                  <Menu.Item
                    disabled
                    key="Penerimaan INV"
                    className={
                      activeMenu ===
                      "/akunting/ar/reportpartners/reportpenerimaaninvoice"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/akunting/ar/reportpartners/reportpenerimaaninvoice"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppstoreOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Penerimaan INV
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>

                  <div
                    className="d-flex justify-content-start"
                    style={{
                      backgroundColor: "",
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Data Wilayah
                    </h6>
                  </div>

                  <Menu.Item
                    key="Master Kecamatan"
                    className={
                      activeMenu === "/masterkecamatan"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterkecamatan"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppstoreOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Data Kecamatan
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Master Kota"
                    className={
                      activeMenu === "/masterkota"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/masterkota" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppstoreOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Data Kota
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Master Provinsi"
                    className={
                      activeMenu === "/masterprovinsi"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterprovinsi"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppstoreOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Data Provinsi
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>

                  {/* <SubMenu key="AP List" title="AP List">
                      <Menu.Item key="SP_AP_LIST">
                        <Link to="/akunting/ap/">
                          <i className="icon icon-widgets" />
                          <span style={{ fontWeight: "bold",  color: 'white' }}>AP List ALL</span>
                        </Link>
                      </Menu.Item>


                    </SubMenu> */}
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Data Tarif
                    </h6>
                  </div>

                  <Menu.Item
                    key="Cari Tarif"
                    className={
                      activeMenu === "/CariTarif"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/CariTarif" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Cari Tarif
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Tarif Eureka"
                    className={
                      activeMenu === "/tarif_eureka"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/tarif_eureka" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Tarif Eureka
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="Tarif Mitra" disabled>
                    <Link to="/tarifmitra" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Tarif Mitra
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Tarif Customer"
                    className={
                      activeMenu === "/DataBUIndex"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/pelanggantarif"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Tarif Customer
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>

                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Bisnis Employee
                    </h6>
                  </div>

                  <Menu.Item
                    key="Data BU"
                    className={
                      activeMenu === "/DataBUIndex"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/DataBUIndex" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UsergroupAddOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Data BU
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Data BU Employee"
                    className={
                      activeMenu === "/DataBuEmployee"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/DataBuEmployee"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserSwitchOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Data BU Employee
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Data BU Brench"
                    className={
                      activeMenu === "/DataBuBrench"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/DataBuBrench" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserAddOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Data BU Brench
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Data Employee Position"
                    className={
                      activeMenu === "/DataBuEmployeePosition"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/DataBuEmployeePosition"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserAddOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Employee Position
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item
                    key="Data Employee Position"
                    className={
                      activeMenu === "/DataBuEmployeePosition"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/DataBuEmployeePosition"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Data Employee Position
                        </span>
                      </div>
                    </Link>
                  </Menu.Item> */}
                </>
              ) : null}

              {jobdesk === "purchasing" && level?.trim()?.toLowerCase() !== "customer" ? (
                <Menu.ItemGroup key="monitorings">
                  <Menu.Item
                    key="Dashboard"
                    className={
                      activeMenu === "/dashboard"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/dashboard" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AppstoreOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Dashboard" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "30%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Menu SP
                    </h6>
                  </div>
                  <Menu.Item
                    key="New SP"
                    className={
                      activeMenu === "/purchasing/newsplist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/purchasing/newsplist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FileProtectOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Request SP" />
                          <Tag
                            // className="tag-hover"
                            style={{
                              marginLeft: "10px",
                              backgroundColor: "#008000",
                              color: "white",
                            }}
                          >
                            {DataRequest}
                          </Tag>
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="SP List"
                    className={
                      activeMenu === "/masterdata/splist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/splist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FileTextOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="SP List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="SO List"
                    className={
                      activeMenu === "/purchasing/solist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/purchasing/solist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FileTextOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="PO List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="LoseSale"
                    className={
                      activeMenu === "/LoseSale"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/LoseSale" style={{ textDecoration: "none" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserSwitchOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Lose Sale
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Menu SJ
                    </h6>
                  </div>
                  <Menu.Item
                    key="SJ List"
                    className={
                      activeMenu === "/masterdata/sjlist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/sjlist"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FolderOpenOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="SJ List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Master
                    </h6>
                  </div>
                  <Menu.Item
                    key="driverpurch"
                    className={
                      activeMenu === "/masterdata/purchasing/driver"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/purchasing/driver"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Master Driver" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Master Mitra"
                    className={
                      activeMenu === "/mastermitra"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/mastermitra" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <ShopOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Master Mitra
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="vehiclepurch"
                    className={
                      activeMenu === "/masterdata/purchasing/vehicle"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/purchasing/vehicle"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-heart" /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FundViewOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Master Vehicle" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <div
                    className="d-flex justify-content-start"
                    style={{
                      height: "20%",
                      marginRight: "20px",
                      marginLeft: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h6
                      style={{ color: "#0c2197", textDecoration: "underline" }}
                      className="mt-3 mb-3 mx-4"
                    >
                      Tarif
                    </h6>
                  </div>
                  <Menu.Item
                    key="Cari Tarif"
                    className={
                      activeMenu === "/CariTarif"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/CariTarif" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Cari Tarif
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Tarif Mitra"
                    className={
                      activeMenu === "/tarifmitra"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/tarifmitra" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Tarif Mitra
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="Tarif Eureka" disabled>
                    <Link to="/tarif_eureka" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" /> */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Tarif Eureka
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="Tarif Customer" disabled>
                    <Link
                      to="/pelanggantarif"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <DollarOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Tarif Customer
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                </Menu.ItemGroup>
              ) : null}

              {/* ////Login Race///// */}
              {jobdesk == "emc" && level?.trim()?.toLowerCase() !== "customer" && (
                <Menu.Item key="Dashboard">
                  <Link to="/admin/race" style={{ textDecoration: "none" }}>
                    {/* <i className="icon icon-widgets" />
                     */}
                    <AppstoreOutlined
                      style={{
                        fontSize: "30px",
                        color: "white",
                        marginBottom: "7px",
                      }}
                    />
                    <span style={{ fontWeight: "bold", color: "black" }}>
                      Dashboard
                    </span>
                  </Link>
                </Menu.Item>
              )}

              {/* ////Login Race Gudang///// */}
              {jobdesk == "rcgudang" && level?.trim()?.toLowerCase() !== "customer" && (
                <>
                  <Menu.Item
                    key="Dashboard"
                    className={
                      activeMenu === "/race/admin/gudang"
                        ? "menu-item-active"
                        : ""
                    }
                    style={{}}
                  >
                    <Link to="/race/admin/gudang">
                      <CustomMenuIcon text="Dashboard" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Dashboard
</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Master Gudang"
                    className={
                      activeMenu === "/race/admin/list/gudang"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/race/admin/list/gudang">
                      <CustomMenuIcon text="Master Gudang" />
<span
                        className="inihuruf"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Master Gudang
</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Master Storage"
                    className={
                      activeMenu === "/race/admin/list/storage"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/race/admin/list/storage">
                      <CustomMenuIcon text="Master Storage" />
<span
                        className="inihuruf"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Master Storage
</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Barang Masuk"
                    className={
                      activeMenu === "/race/admin/list/barang/masuk"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/race/admin/list/barang/masuk">
                      <CustomMenuIcon text="Barang Masuk" />
<span
                        className="inihuruf"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Barang Masuk
</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Barang Keluar"
                    className={
                      activeMenu === "/race/admin/list/barang/keluar"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/race/admin/list/barang/keluar">
                      <CustomMenuIcon text="Barang Keluar" />
<span
                        className="inihuruf"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Barang Keluar
</span>
                    </Link>
                  </Menu.Item>
                </>
              )}

              {/* ////Login Customer Level///// */}
              {level?.trim()?.toLowerCase() === "customer" && (
                <>
                  <Menu.Item
                    key="SPList"
                    className={
                      activeMenu === "/race/splist" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/race/splist">
                      <CustomMenuIcon text="SP List" />
<span
                        className="inihuruf"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  SP List
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="sjlista"
                    className={
                      activeMenu === "/race/sjlist" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/race/sjlist">
                      <CustomMenuIcon text="SJ List" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  SJ List
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="sjsusulan"
                    className={
                      activeMenu === "/race/sjsusulan" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/race/sjsusulan">
                      <CustomMenuIcon text="SJ Susulan" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  SJ Susulan
</span>
                    </Link>
                  </Menu.Item>
                </>
              )}

              {/* ////Login Race///// */}
              {(jobdesk === "rcadmin" || jobdesk === "rcspv") && cabang && level?.trim()?.toLowerCase() !== "customer" && (
                <>
                  <Menu.Item
                    key="Dashboard"
                    className={
                      activeMenu === "/Dashboard" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/Dashboard">
                      <CustomMenuIcon text="Dashboard" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Dashboard
</span>
                    </Link>
                  </Menu.Item>



                  <Menu.Item
                    key="erlangga"
                    className={
                      activeMenu === "/erlangga" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/erlangga">
                      <CustomMenuIcon text="Erlangga" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Erlangga
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="SPList"
                    className={
                      activeMenu === "/race/splist" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/race/splist">
                      <CustomMenuIcon text="SP List" />
<span
                        className="inihuruf"
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  SP List
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="sjlista"
                    className={
                      activeMenu === "/race/sjlist" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/race/sjlist">
                      <CustomMenuIcon text="SJ List" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  SJ List
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="sjsusulan"
                    className={
                      activeMenu === "/race/sjsusulan" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/race/sjsusulan">
                      <CustomMenuIcon text="SJ Susulan" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  SJ Susulan
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="sjpending"
                    className={
                      activeMenu === "/race/sj-pending"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/race/sj-pending">
                      <CustomMenuIcon text="SJ Pending" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  SJ Pending
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="mapping2"
                    className={
                      activeMenu === "/mapping2" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/mapping2">
                      <CustomMenuIcon text="Map Pengiriman" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Map Pengiriman
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="ReportKirimanRace"
                    className={
                      activeMenu === "/ReportKirimanRace"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/ReportKirimanRace">
                      <CustomMenuIcon text="Monitoring Report" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Monitoring Report
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="returorder"
                    className={
                      activeMenu === "/race/returorder"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/race/returorder">
                      <CustomMenuIcon text="Return Order" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Return Order
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="newsp"
                    className={
                      activeMenu === "/race/reporthariandriverrace"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/race/reporthariandriverrace">
                      <CustomMenuIcon text="Report Driver Harian" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Report Driver Harian
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="receivesj"
                    className={
                      activeMenu === "/race/receivesj" ? "menu-item-active" : ""
                    }
                  >
                    <Link to="/race/receivesj">
                      <CustomMenuIcon text="Receive SJ" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  Receive SJ
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="historyreceivesj"
                    className={
                      activeMenu === "/receive/history/sj"
                        ? "menu-item-active"
                        : ""
                    }
                  >
                    <Link to="/receive/history/sj">
                      <CustomMenuIcon text="History Receive SJ" />
<span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          marginLeft: "4%",
                        }}
                      >
  History Receive SJ
</span>
                    </Link>
                  </Menu.Item>

                  <SubMenu
                    key="master_data"
                    title={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CustomMenuIcon text="Master Data" />
                        <span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
                          Master Data
                        </span>
                      </div>
                    }
                    style={{
                      color: "white",
                      marginTop: "7px",
                    }}
                  >
                    <Menu.Item
                      key="vehicle"
                      className={
                        activeMenu === "/race/kendaraan"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/kendaraan">
                        <CustomMenuIcon text="Kendaraan" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Kendaraan
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="driver"
                      className={
                        activeMenu === "/race/driver" ? "menu-item-active" : ""
                      }
                    >
                      <Link to="/race/driver">
                        <CustomMenuIcon text="Driver" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Driver
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="mapping"
                      className={
                        activeMenu === "/race/alamatcustomer"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/alamatcustomer">
                        <CustomMenuIcon text="Alamat Customer" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Alamat Customer
</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  <SubMenu
                    key="lain_lain"
                    title={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CustomMenuIcon text="Lain-lain" />
                        <span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
                          Lain-lain
                        </span>
                      </div>
                    }
                    style={{
                      color: "white",
                      marginTop: "7px",
                    }}
                  >
                    <Menu.Item
                      key="smmetrics"
                      className={
                        activeMenu === "/race/sm-metrics"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/sm-metrics">
                        <CustomMenuIcon text="SM Metrics" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  SM Metrics
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="visual-mapping"
                      className={
                        activeMenu === "/visual-mapping"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/visual-mapping">
                        <CustomMenuIcon text="Driver Activity" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Driver Activity
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="national-operation-dashboard"
                      className={
                        activeMenu === "/national-operation-dashboard"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/national-operation-dashboard">
                        <CustomMenuIcon text="Exec Dashboard" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Exec Dashboard
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="list-revisi"
                      className={
                        activeMenu === "/race/list-revisi"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/list-revisi">
                        <CustomMenuIcon text="List Revisi" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  List Revisi
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="report-faktur"
                      className={
                        activeMenu === "/race/report-faktur"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/report-faktur">
                        <CustomMenuIcon text="Report Faktur" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Report Faktur
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="uangjalan"
                      className={
                        activeMenu === "/race/uangjalan"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/uangjalan">
                        <CustomMenuIcon text="Uang Jalan" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Uang Jalan
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="scan"
                      className={
                        activeMenu === "/race/scan" ? "menu-item-active" : ""
                      }
                    >
                      <Link to="/race/scan">
                        <CustomMenuIcon text="Scan Barang" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Scan Barang
</span>
                      </Link>
                    </Menu.Item>
                    {/* <Menu.Item
                      key="ptj"
                      className={
                        activeMenu === "/race/ptj" ? "menu-item-active" : ""
                      }
                    >
                      <Link to="/race/ptj">
                        <CustomMenuIcon text="PTJ" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  PTJ
</span>
                      </Link>
                    </Menu.Item> */}
                    <Menu.Item
                      key="checkinpool"
                      className={
                        activeMenu === "/race/checkinpool"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/checkinpool">
                        <CustomMenuIcon text="Checkin Pool" />
<span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
  Checkin Pool
</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  <SubMenu
                    key="sub3"
                    title={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CustomMenuIcon text="Personalia" />
                        <span
                          style={{
                            color: "white",
                            textDecoration: "none",
                            marginLeft: "4%",
                          }}
                        >
                          Personalia
                        </span>
                      </div>
                    }
                    style={{
                      color: "white",
                      marginTop: "7px",
                    }}
                  >
                    <Menu.Item
                      key="penggajian"
                      className={
                        activeMenu === "/race/penggajian"
                          ? "menu-item-active"
                          : ""
                      }
                    >
                      <Link to="/race/penggajian">
                        <CustomMenuIcon text="Penggajian" />
<span style={{ color: "white", marginLeft: "4%" }}>
  Penggajian
</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="Absensi"
                      className={
                        activeMenu === "/race/absensi" ? "menu-item-active" : ""
                      }
                    >
                      <Link to="/race/absensi">
                        <CustomMenuIcon text="Absensi" />
<span style={{ color: "white", marginLeft: "4%" }}>
  Absensi
</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>

                  {/* </SubMenu> */}
                </>
              )}

              {loginBu && jobdesk == "akunting" && (
                <div className="mt-4">
                  <Menu.Item
                    className={
                      activeMenu === "/race/cabang/dashboard"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="cabang"
                  >
                    <Link
                      to="/race/cabang/dashboard"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="Dashboard" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  Dashboard
</span>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item
                    className={
                      activeMenu === "race/cabang/splist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="SPList"
                  >
                    <Link
                      to="/race/cabang/splist"
                      style={{ textDecoration: "none" }}
                    >
                      

                      <CustomMenuIcon text="SP List Race3" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SP List Race3
</span>
                    </Link>
                  </Menu.Item> */}
                  {/* <Menu.Item
                     className={
                       activeMenu === "/race/cabang/sjlistt"
                         ? "menu-item-active menu-item-hover"
                         : "menu-item-hover"
                     }
                     key="cabangSJListHanyaLihat"
                   >
                     <Link
                       to="/race/cabang/sjlistt"
                       style={{ textDecoration: "none" }}
                     >
                    

                       <CustomMenuIcon text="SJ List Cabang" />
<span
                         className="mx-3"
                         style={{ fontWeight: "bold", color: "white" }}
                       >
  SJ List Cabang
</span>
                     </Link>
                   </Menu.Item> */}
                  <Menu.Item
                    className={
                      activeMenu === "/race/cabang/sjlist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="sjlist"
                  >
                    <Link
                      to="/race/cabang/sjlist"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="SJ List" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SJ List
</span>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item
                    className={
                      activeMenu === "/race/reporthariandriverrace"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="newsp"
                  >
                    <Link
                      to="/race/reporthariandriverrace"
                      style={{ textDecoration: "none" }}
                    >
                      <CustomMenuIcon text="Report Driver Harian" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  Report Driver Harian
</span>
                    </Link>
                  </Menu.Item> */}
                  {/* <Menu.Item
                      className={
                        activeMenu === "/race/cabang/splistt"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                      key="cabangSpListHanyaLihat"
                    >
                      <Link
                        to="/race/cabang/splistt"
                        style={{ textDecoration: "none" }}
                      >
                       
                        <CustomMenuIcon text="SP List Cabang" />
<span
                          className="mx-3"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
  SP List Cabang
</span>
                      </Link>
                    </Menu.Item> */}
                </div>
              )}
              {cabang && jobdesk == "keuangan" && (
                <div className="mt-4">
                  <Menu.Item
                    className={
                      activeMenu === "/race/cabang/dashboard"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="cabang"
                  >
                    <Link
                      to="/race/cabang/dashboard"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="Dashboard" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  Dashboard
</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    className={
                      activeMenu === "/race/splist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="SPList"
                  >
                    <Link to="/race/splist" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="SP List Race" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SP List Race
</span>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item
                     className={
                       activeMenu === "/race/cabang/sjlistt"
                         ? "menu-item-active menu-item-hover"
                         : "menu-item-hover"
                     }
                     key="cabangSJListHanyaLihat"
                   >
                     <Link
                       to="/race/cabang/sjlistt"
                       style={{ textDecoration: "none" }}
                     >
                    

                       <CustomMenuIcon text="SJ List Cabang" />
<span
                         className="mx-3"
                         style={{ fontWeight: "bold", color: "white" }}
                       >
  SJ List Cabang
</span>
                     </Link>
                   </Menu.Item> */}
                  <Menu.Item
                    className={
                      activeMenu === "/race/sjlist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="sjlist"
                  >
                    <Link to="/race/sjlist" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="SJ List" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SJ List
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    className={
                      activeMenu === "/race/sjsusulan"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="sjsusulan"
                  >
                    <Link to="/race/sjsusulan" style={{ textDecoration: "none" }}>
                      <CustomMenuIcon text="SJ Susulan" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SJ Susulan
</span>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item
                      className={
                        activeMenu === "/race/cabang/splistt"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                      key="cabangSpListHanyaLihat"
                    >
                      <Link
                        to="/race/cabang/splistt"
                        style={{ textDecoration: "none" }}
                      >
                       
                        <CustomMenuIcon text="SP List Cabang" />
<span
                          className="mx-3"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
  SP List Cabang
</span>
                      </Link>
                    </Menu.Item> */}
                </div>
              )}
              {cabang && jobdesk == "logistik" && (
                <div className="mt-4">
                  <Menu.Item
                    className={
                      activeMenu === "/race/cabang/dashboard"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="cabang"
                  >
                    <Link
                      to="/race/cabang/dashboard"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="Dashboard" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  Dashboard
</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    className={
                      activeMenu === "/race/splist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="SPList"
                  >
                    <Link to="/race/splist" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="SP List Race" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SP List Race
</span>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item
                     className={
                       activeMenu === "/race/cabang/sjlistt"
                         ? "menu-item-active menu-item-hover"
                         : "menu-item-hover"
                     }
                     key="cabangSJListHanyaLihat"
                   >
                     <Link
                       to="/race/cabang/sjlistt"
                       style={{ textDecoration: "none" }}
                     >
                    

                       <CustomMenuIcon text="SJ List Cabang" />
<span
                         className="mx-3"
                         style={{ fontWeight: "bold", color: "white" }}
                       >
  SJ List Cabang
</span>
                     </Link>
                   </Menu.Item> */}
                  <Menu.Item
                    className={
                      activeMenu === "/race/sjlist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="sjlist"
                  >
                    <Link to="/race/sjlist" style={{ textDecoration: "none" }}>
                      {/* <i className="icon icon-widgets" />
                       */}

                      <CustomMenuIcon text="SJ List" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SJ List
</span>
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    className={
                      activeMenu === "/race/sjsusulan"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                    key="sjsusulan"
                  >
                    <Link to="/race/sjsusulan" style={{ textDecoration: "none" }}>
                      <CustomMenuIcon text="SJ Susulan" />
<span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
  SJ Susulan
</span>
                    </Link>
                  </Menu.Item>
                  {/* <Menu.Item
                      className={
                        activeMenu === "/race/cabang/splistt"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                      key="cabangSpListHanyaLihat"
                    >
                      <Link
                        to="/race/cabang/splistt"
                        style={{ textDecoration: "none" }}
                      >
                       
                        <CustomMenuIcon text="SP List Cabang" />
<span
                          className="mx-3"
                          style={{ fontWeight: "bold", color: "white" }}
                        >
  SP List Cabang
</span>
                      </Link>
                    </Menu.Item> */}
                </div>
              )}
              {/* <>===========</> */}

              {jobdesk == "webmaster" && level?.trim()?.toLowerCase() !== "customer" && (
                <MenuItemGroup key="main">
                  <Menu.Item
                    key="Dashboard"
                    className={
                      activeMenu === "/dashboard"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/dashboard" style={{ textDecoration: "none" }}>
                      <AppstoreOutlined
                        style={{
                          fontSize: "30px",
                          color: "white",
                          marginBottom: "8px",
                        }}
                      />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        <IntlMessages id="Dashboard" />
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="List User"
                    className={
                      activeMenu === "/admin/user/menu"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/admin/user/menu"
                      style={{ textDecoration: "none" }}
                    >
                      <UsergroupAddOutlined
                        style={{
                          fontSize: "30px",
                          color: "white",
                          marginBottom: "8px",
                        }}
                      />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        <IntlMessages id="List User" />
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="Data User"
                    className={
                      activeMenu === "/DataMenu"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link to="/DataMenu" style={{ textDecoration: "none" }}>
                      <UserOutlined
                        style={{
                          fontSize: "30px",
                          color: "white",
                          marginBottom: "8px",
                        }}
                      />
                      <span style={{ fontWeight: "bold", color: "black" }}>
                        <IntlMessages id="Data User" />
                      </span>
                    </Link>
                  </Menu.Item>
                </MenuItemGroup>
              )}

              {jobdesk == "monitoring" && level?.trim()?.toLowerCase() !== "customer" && (
                <>
                  <Menu.Item
                    key="List User"
                    className={
                      activeMenu === "/monitoring/report-kiriman"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/monitoring/report-kiriman"
                      style={{ textDecoration: "none" }}
                    >
                      <span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Report Kiriman
                      </span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="List User"
                    className={
                      activeMenu === "/monitoring/monitoring-unit"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/monitoring/monitoring-unit"
                      style={{ textDecoration: "none" }}
                    >
                      <span
                        className="mx-3"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Monitoring Unit
                      </span>
                    </Link>
                  </Menu.Item>
                </>
              )}

              {jobdesk === "kacab" && level?.trim()?.toLowerCase() !== "customer" && (
                <>
                  <Menu.Item
                    key="SP List"
                    className={
                      activeMenu === "/masterdata/marketing/splist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/marketing/splist"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FileTextOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="SP List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="SJ List"
                    className={
                      activeMenu === "/masterdata/sjlist"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/masterdata/sjlist"
                      style={{ textDecoration: "none" }}
                    >
                      {/* <i className="icon icon-widgets" />
                       */}
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FolderOpenOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="SJ List" />
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="MasterCustomer"
                    className={
                      activeMenu === "/ReportCustomer"
                        ? "menu-item-active menu-item-hover"
                        : "menu-item-hover"
                    }
                  >
                    <Link
                      to="/ReportCustomer"
                      style={{ textDecoration: "none" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <UserSwitchOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          Report Customer
                        </span>
                      </div>
                    </Link>
                  </Menu.Item>
                  <Menu.SubMenu
                    title={
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FolderOpenOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "8px",
                          }}
                        >
                          <IntlMessages id="Master Kendaraan" />
                        </span>
                      </div>
                    }
                  >
                    <Menu.Item
                      key="driverpurch"
                      className={
                        activeMenu === "/masterdata/purchasing/driver"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/masterdata/purchasing/driver"
                        style={{ textDecoration: "none" }}
                      >
                        {/* <i className="icon icon-widgets" />
                         */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <SmileTwoTone
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            <IntlMessages id="Master Driver" />
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="vehicle"
                      className={
                        activeMenu === "/masterdata/vehicle"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/masterdata/vehicle"
                        style={{ textDecoration: "none" }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <CarTwoTone
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            <IntlMessages id="sidebar.vehicle" />
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                  </Menu.SubMenu>

                  <Menu.SubMenu
                    title={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "",
                        }}
                      >
                        <FolderOpenOutlined
                          style={{
                            fontSize: "30px",
                            color: "black",
                            marginBottom: "8px",
                            marginTop: "10px",
                          }}
                        />
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            marginLeft: "",
                          }}
                        >
                          <IntlMessages id="Master Tarif" />
                        </span>
                      </div>
                    }
                  >
                    <Menu.Item
                      key="Master Tarif"
                      className={
                        activeMenu === "/mastermitra"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/mastermitra"
                        style={{ textDecoration: "none" }}
                      >
                        {/* <i className="icon icon-widgets" />
                         */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <ShopOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            Master Mitra
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="Tarif Mitra"
                      className={
                        activeMenu === "/tarifmitra"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link to="/tarifmitra" style={{ textDecoration: "none" }}>
                        {/* <i className="icon icon-widgets" />
                         */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <DollarOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            Tarif Mitra
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="Tarif Eureka"
                      className={
                        activeMenu === "/tarif_eureka"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/tarif_eureka"
                        style={{ textDecoration: "none" }}
                      >
                        {/* <i className="icon icon-widgets" /> */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <DollarOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            Tarif Eureka
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="Cari Tarif"
                      className={
                        activeMenu === "/CariTarif"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link to="/CariTarif" style={{ textDecoration: "none" }}>
                        {/* <i className="icon icon-widgets" /> */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <DollarOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            Cari Tarif
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="Tarif Customer"
                      className={
                        activeMenu === "/pelanggantarif"
                          ? "menu-item-active menu-item-hover"
                          : "menu-item-hover"
                      }
                    >
                      <Link
                        to="/pelanggantarif"
                        style={{ textDecoration: "none" }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <DollarOutlined
                            style={{
                              fontSize: "30px",
                              color: "black",
                              marginBottom: "8px",
                              marginTop: "10px",
                            }}
                          />
                          <span
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              marginLeft: "8px",
                            }}
                          >
                            Tarif Customer
                          </span>
                        </div>
                      </Link>
                    </Menu.Item>
                  </Menu.SubMenu>
                </>
              )}
              {/* ADMIN RACE CABANG */}
            </MenuItemGroup>
          </Menu>
          {/* <Menu
            style={{
              width: "100%",
            }}
            defaultSelectedKeys={["1"]}
            defaultOpenKeys={["sub1"]}
            mode="inline"
            items={items}
          /> */}
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
